import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initSentry } from "./lib/sentry";
import "./index.css";

initSentry();

function AppErrorFallback({
  resetError,
}: {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="max-w-md rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6 text-center shadow-sm">
        <h1 className="text-xl font-semibold tracking-tight text-[var(--ink-primary)]">
          Ocurrió un error inesperado
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-[hsl(var(--muted-foreground))]">
          El error fue reportado. Reintentá cargar la aplicación.
        </p>
        <button
          className="mt-5 inline-flex h-10 items-center justify-center rounded-lg bg-[var(--ink-primary)] px-4 text-sm font-medium text-[var(--accent-raw)]"
          onClick={resetError}
          type="button"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary fallback={AppErrorFallback}>
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
);
